import './WhyUsCard.sass';

const WhyUsCard = (props) => {
    return (
        <article className={'why-us-card'}>
            <h2>{props.header}</h2>
            <div>
                {props.children}
            </div>
            <p className='icon d-flex justify-content-end'>”</p>
        </article>
    );
};

export default WhyUsCard;